// eslint-disable-next-line
import { RouteView } from '@/layouts'
//测试使用
export const testRouterRouter = [{
  path: '/test',
  redirect: '/test/dragging/list',
  component: RouteView,
  meta: { title: 'demo', keepAlive: true, icon: 'question', ignorePermissions: true },
  ignorePermissions: true,//忽略权限控制(忽略的包括里面的所有孩子)
  children: [
    {
      path: '/test/dragging/list',
      name: 'TestCustomDraggingList',
      meta: { title: '测试拖拽组件', keepAlive: false, ignorePermissions: true },
      component: () => import('@/test/TestCustomDraggingList'),
      ignorePermissions: true
    },
    {
      path: '/test/draggingTable',
      name: 'TestDraggingTable',
      meta: { title: '拖拽table', keepAlive: false, ignorePermissions: true },
      component: () => import('@/test/TestDraggingTable'),
      ignorePermissions: true
    },
    {
      path: '/test/pagingDraggingList',
      name: 'TestPagingDraggingList',
      meta: { title: '分页拖拽', keepAlive: false, ignorePermissions: true },
      component: () => import('@/test/TestPagingDraggingList'),
      ignorePermissions: true
    },
    {
      path: '/test/testTable',
      name: 'testTable',
      meta: { title: '拖拽', keepAlive: false, ignorePermissions: true },
      component: () => import('@/test/testTable'),
      ignorePermissions: true
    },
    {
      path: '/test/page/list',
      name: 'TestPageList',
      meta: { title: '高度封装搜索页', keepAlive: false, ignorePermissions: true },
      component: () => import('@/test/TestPageList'),
      ignorePermissions: true
    }
  ]
}]